import { createGenericSlice } from './generic.slice'
import { RootState } from '@store/store'

export const audioUrl = 'audio'
export interface AudioModel {
  id: string
  audioName: string
  audioSource: string
  createdAt: string
  createdBy: string
  audioUrl: string
}

const {
  slice: audioSlice,
  thunks: audioThunks,
  adapter: audioAdapter,
} = createGenericSlice<AudioModel>(
  'Audio',
  'audio',
  {} // Initial state can be customized if needed
)

export const {
  selectById: selectAudioById,
  // ... other selectors
} = audioAdapter.getSelectors<RootState>((state: RootState) => state.audios)

export const { fetchById: fetchAudioById } = audioThunks

export default audioSlice.reducer
